"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveButtonStyled = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var colors = _interopRequireWildcard(require("../../../constants/colors"));
var _button = require("../../button");
const RemoveButtonStyledLodestar = (0, _styled.default)(_button.Button)`
    font-weight: normal;
    color: ${colors.buttonDestructive}; //no token exists
    height: 32px;
    font-size: 13px;

    &:focus {
        color: ${colors.buttonDestructiveFocus}; //no token exists
    }
    &:hover {
        color: ${(0, _designTokensReact.color)("color--background--destructive--weak")};
    }
    &:active {
        color: ${(0, _designTokensReact.color)("color--background--destructive--strong")};
    }
    &:disabled {
        color: ${colors.buttonDestructiveDisabled}; //no token exists
    }
`;
const RemoveButtonStyledUrsa = props => /*#__PURE__*/_react.default.createElement(_button.Button, (0, _extends2.default)({
  iconBefore: /*#__PURE__*/_react.default.createElement(_ursaIcons.TrashcanIcon, {
    size: 24,
    color: "currentColor"
  }),
  appearance: "destructive-filled",
  size: "medium"
}, props));
const RemoveButtonStyled = _ref => {
  let {
    themeMode,
    ...rest
  } = _ref;
  if (themeMode.includes("ursa")) {
    return /*#__PURE__*/_react.default.createElement(RemoveButtonStyledUrsa, rest);
  } else {
    return /*#__PURE__*/_react.default.createElement(RemoveButtonStyledLodestar, (0, _extends2.default)({
      appearance: "borderless"
    }, rest));
  }
};
exports.RemoveButtonStyled = RemoveButtonStyled;
//# sourceMappingURL=RemoveButtonStyled.js.map